// extracted by mini-css-extract-plugin
export var container = "Addindividualform-module--container--MGsjc";
export var submit = "Addindividualform-module--submit--Gk9Sb";
export var fadeIn = "Addindividualform-module--fadeIn--2Tgr_";
export var moveLeft = "Addindividualform-module--moveLeft--32a2C";
export var moveDown = "Addindividualform-module--moveDown--jLRXT";
export var illuMoveDown = "Addindividualform-module--illuMoveDown--3Wll0";